//initial redux
import { put, call, takeEvery, fork, all, take, cancel, select } from "redux-saga/effects";
import config from "./config";
import * as router from "react-router-redux";
import { types as logintypes } from "../ui/Login/redux";
import routes from "./routeConfig";
import { nestedRoutes } from "./routeConfig";

export let persistor = { persistor: {} };

const DEFUALT_ROUTE = "/Sites";

const initialState = {
	uri: DEFUALT_ROUTE,
	params: null,
	$persist: [],

	loaded: false
};

/////////
//types
export const types = {
	STORE_URI: "boot/setup/STORE_URI",
	PURGE_PERSIST: "boot/setup/PURGE_PERSIST",
	CLEAR_STATE: "boot/setup/CLEAR_STATE"
};

///////////
//reducers
export const reducers = {
	reducer(state = initialState, action) {
		switch (action.type) {
			case types.STORE_URI:
				return {
					...state,
					uri: action.payload.uri,
					params: action.payload.params,
					$persist: [],
					loaded: true
				};
			case "persist/REHYDRATE":
				return { ...state, $persist: state.$persist.concat(action.payload) };
			default:
				return state;
		}
	}
};

//////////
//sagas
export const sagas = {
	*rootSaga() {
		yield all([this.onBoot(), this.purgePersist()]);
	},

	*purgePersist() {
		yield takeEvery([logintypes.CLEAR_STATE, types.PURGE_PERSIST], function*(action) {
			if (persistor.persistor.purge) {
				// localStorage.removeItem("persist:root");
				persistor.persistor.purge();
				console.log("Purge Complete");
				yield put(actions.clearState());
			}
		});
	},

	*onBoot() {
		yield takeEvery(
			[types.STORE_URI, logintypes.ON_LOGIN],
			function*(action) {
				yield call(this.nav, action.type === logintypes.ON_LOGIN);
			}.bind(this)
		);
	},

	*nav(isLogin) {
		//logged in goto home or pasted url
		const route = yield select(x => x.setup);
		console.log("Initial route: " + route.uri);

		// Nav to initial route only if it exists or a nested route matching it exists
		let combinedRoutes = [...routes, ...nestedRoutes];
		const routeObj = combinedRoutes.find(x => {
			let path = x.path;
			if (path.includes(":")) {
				const index = path.indexOf(":");
				path = path.substr(0, index);
				return route.uri.substr(0, index) === path;
			} else {
				return path === route.uri;
			}
		});

		if (!routeObj) {
			route.uri = DEFUALT_ROUTE;
			route.params = null;
		}

		let url = window.location.href;
		let routeHasIdToken = url.includes("#id_token=");
		let routeHasSessionState = url.includes("&session_state=");
		if(routeHasIdToken && routeHasSessionState) {
			let start = url.indexOf("#id_token=") + 10;
			let end = url.indexOf("&session_state=");
			let msalIdToken = url.substring(start, end);
			localStorage.setItem('redi-msal', msalIdToken);
		}

		if (isLogin && route.uri === "/Login") {
			//goto home instead
			yield put(router.push(DEFUALT_ROUTE));
		} else {
			yield put(router.push(route.uri, route.params));
		}
	}
};

////////
//actions
export const actions = {
	clearState() {
		return {
			type: types.CLEAR_STATE,
			payload: {}
		};
	},

	genericAction(type, data) {
		return {
			type,
			payload: data
		};
	}
};



// WEBPACK FOOTER //
// ./src/boot/setupRedux.js